import { StyleSheet } from "react-native";
import { View } from "~/components/V2/View";
import { useResponsive } from "~/hooks/useResponsive";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import type { PropsWithChildren } from "react";
import type { ViewStyle } from "react-native";

const S = StyleSheet.create({
  container: {
    paddingVertical: 56,
    flex: 1,
  },
  card: {
    maxWidth: 615,
    width: "100%",
    borderRadius: 20,
    overflow: "hidden",
    marginHorizontal: "auto",
    backgroundColor: styleConstantsV2.colorWhite,
  },
});

export const Layout = ({
  children,
  cardStyle,
  mobileContainerStyle,
  webContainerStyle,
}: PropsWithChildren<{
  cardStyle?: ViewStyle;
  mobileContainerStyle?: ViewStyle;
  webContainerStyle?: ViewStyle;
}>) => {
  const r = useResponsive();
  const isWeb = r(false, false, true);

  if (!isWeb) {
    return <View style={[mobileContainerStyle, { flex: 1 }]}>{children}</View>;
  }

  return (
    <View style={[S.container, webContainerStyle]}>
      <View flex style={[S.card, cardStyle]}>
        {children}
      </View>
    </View>
  );
};
